import { curativeGradeColors, eCurativeGrade, prettyCurativeGrade } from '../../enums/eCurativeGrade';
import { ISelectOption, ISelectProps, Select } from '../Select';
import classnames from 'classnames';
import { FormCell } from '../FormCell';
import React from 'react';

export interface IDottedOptionData extends ISelectOption {
  color?: string; // color hex
}

export const getColoredCurativeGradeOptions = (): IDottedOptionData[] => {
  return Object.values(eCurativeGrade).map((e) => ({
    label: prettyCurativeGrade[e],
    value: e,
    color: curativeGradeColors[e],
  }));
};

export const getCurativeGradeDot = (data: IDottedOptionData) => ({
  display: 'flex',
  alignItems: 'center',
  ':before': {
    content: '""',
    backgroundColor: data.color,
    display: 'block',
    height: '15px',
    width: '15px',
    borderRadius: '50%',
    marginRight: '8px',
  },
});

interface ICurativeGradeProps extends ISelectProps {
  className?: string;
  isRequired?: boolean;
  label?: string;
}

export const CurativeGradeInput = ({
  className,
  label,
  isRequired,
  placeholder,
  onChange,
  value,
  isClearable,
}: ICurativeGradeProps) => {
  const options = getColoredCurativeGradeOptions();
  const boxValue = options.find((opt) => opt.value === value);

  return (
    <div className={classnames(className)}>
      <FormCell label={label} isRequired={isRequired}>
        <Select
          isClearable={isClearable}
          value={boxValue}
          placeholder={placeholder}
          onChange={onChange}
          styles={{
            option: (baseStyles, { data }) => ({
              ...baseStyles,
              ...getCurativeGradeDot(data),
            }),
            singleValue: (baseStyles, { data }) => ({
              ...baseStyles,
              ...getCurativeGradeDot(data),
            }),
          }}
          options={options}
        />
      </FormCell>
    </div>
  );
};
